module.exports = {
  "version": "0.27.2"
};


//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/~/axios/lib/env/data.js
// module id = 52
// module chunks = 0